import { img } from '../data/siteData';

function Hero({ eyebrow, title, description, image = 'equipment/horizontal-balers/horizontal-7.jpg', compact = false }) {
  return (
    <section
      className={compact ? 'page-hero compact' : 'page-hero'}
      style={{ backgroundImage: `linear-gradient(90deg,rgba(7,16,38,.94),rgba(7,16,38,.58)),url(${img(image)})` }}
    >
      <link rel="preload" as="image" href={img(image)} fetchPriority="high" />
      <div>
        <span>{eyebrow}</span>
        <h1 style={{textTransform: "uppercase", letterSpacing: "1.5px"}}>{title}</h1>
        <p>{description}</p>
      </div>
    </section>
  );
}

export default Hero;
